"use strict";

var _slicedToArray = require("/home/runner/work/react-nexys-boilerplate/react-nexys-boilerplate/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importStar(require("react"));

var styles_1 = require("@material-ui/core/styles");

var core_1 = require("@material-ui/core");

var U = __importStar(require("./utils"));

var useStyles = styles_1.makeStyles(function (theme) {
  return {
    root: {
      width: '100%',
      maxWidth: 360,
      backgroundColor: theme.palette.background.paper
    },
    inline: {
      display: 'inline'
    }
  };
});

exports.default = function (props) {
  var classes = useStyles();
  var data = props.data,
      prefix = props.prefix,
      deleteFunc = props.deleteFunc,
      showCopy = props.showCopy;

  var _react_1$useState = react_1.useState(data),
      _react_1$useState2 = _slicedToArray(_react_1$useState, 2),
      list = _react_1$useState2[0],
      setList = _react_1$useState2[1];

  var _react_1$useState3 = react_1.useState(false),
      _react_1$useState4 = _slicedToArray(_react_1$useState3, 2),
      loading = _react_1$useState4[0],
      setLoading = _react_1$useState4[1];

  var handleDelete = function handleDelete(uuid) {
    if (!deleteFunc) {
      return undefined;
    }

    setLoading(true);
    deleteFunc(uuid).then(function (x) {
      var newList = list.filter(function (x) {
        return x.uuid !== uuid;
      });
      setList(newList);
      setLoading(false);
    });
  };

  if (list.length === 0) {
    return react_1.default.createElement("p", null, "No files");
  }

  return react_1.default.createElement(react_1.default.Fragment, null, react_1.default.createElement(U.Alert, {
    loading: loading
  }, "The list is being refreshed"), react_1.default.createElement(core_1.List, {
    className: classes.root
  }, list.map(function (x, i) {
    return react_1.default.createElement(U.ListUnit, {
      key: i,
      uuid: x.uuid,
      prefix: prefix,
      name: x.name,
      contentType: x.contentType,
      onDelete: handleDelete,
      showCopy: showCopy
    });
  })));
};